import { render, staticRenderFns } from "./PopupNoticeEdit.vue?vue&type=template&id=412fc523&scoped=true&"
import script from "./PopupNoticeEdit.vue?vue&type=script&lang=js&"
export * from "./PopupNoticeEdit.vue?vue&type=script&lang=js&"
import style0 from "./PopupNoticeEdit.vue?vue&type=style&index=0&id=412fc523&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412fc523",
  null
  
)

export default component.exports